import { Plus } from "lucide-react";

/**
 * "Add vocabulary packs" section — layers a pre-built tile pack (halal,
 * kosher, vegan, prayer, holidays, expanded feelings) onto the existing
 * board. Idempotent on the backend so re-adding is a no-op.
 *
 * Pure presentation — Settings.jsx owns the data load + addAddonPack
 * mutation and just passes the slice down.
 */
const PACK_LABELS = {
  halal:         { label: "Halal food",          emoji: "🥘" },
  kosher:        { label: "Kosher food",         emoji: "✡️" },
  vegetarian:    { label: "Vegetarian",          emoji: "🥦" },
  vegan:         { label: "Vegan",               emoji: "🌱" },
  prayer:        { label: "Prayer & gratitude",  emoji: "🙏" },
  holidays:      { label: "Holidays",            emoji: "🎉" },
  feelings_plus: { label: "Expanded feelings",   emoji: "💫" },
};

export default function AddOnPacksSection({ packs, busy, result, onAdd }) {
  return (
    <section className="brutal-card bg-white p-5 mb-4" data-testid="addon-packs-section">
      <h2 className="display text-xl font-bold mb-2 flex items-center gap-2">
        <Plus size={18} className="text-[color:var(--coral)]" />
        Add vocabulary packs
      </h2>
      <p className="text-[color:var(--ink-soft)] mb-3">
        Layer a culturally-relevant or expanded set of tiles onto this board.
        Tiles are added to existing categories — nothing on the board gets
        removed. Re-adding the same pack is a no-op.
      </p>
      {result && (
        <div
          className="brutal-card bg-[color:var(--gold)] p-2 mb-3 text-sm display font-semibold"
          data-testid="addon-result"
        >
          {result}
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {packs.map((p) => {
          const meta = PACK_LABELS[p.id] || { label: p.id, emoji: "✨" };
          return (
            <div
              key={p.id}
              className="flex items-center gap-3 px-3 py-2 rounded-xl border-[3px] border-[color:var(--ink)] bg-[color:var(--paper-muted)]"
              data-testid={`addon-${p.id}`}
            >
              <span className="text-3xl" aria-hidden>{meta.emoji}</span>
              <div className="flex-1 min-w-0">
                <div className="display font-bold">{meta.label}</div>
                <div className="text-xs text-[color:var(--ink-soft)] truncate">
                  → {p.category} · {p.preview.slice(0, 3).join(", ")}…
                </div>
              </div>
              <button
                type="button"
                onClick={() => onAdd(p.id)}
                disabled={busy === p.id}
                className="pill-btn primary"
                data-testid={`addon-add-${p.id}`}
              >
                {busy === p.id ? "…" : (<><Plus size={14} /> Add</>)}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
